import React, { useEffect, useRef } from 'react';
import TrailSwitch from './TrailSwitch';
import LoadingState from './LoadingState';
import './TrailFrame.css';

// The one frame of Revisionsspor, the same on Beslutninger, IT-opgaver and Historik: ONE menu card (the switch on top, the tabs under it, the
// sorting and the search under those), only as wide as the list, and the page's own content (list + side panel) below it.
export function TrailTabs({ items, current, onChange, label }) {
  return (
    <div className="tf-tabs" role="tablist" aria-label={label}>
      {items.map((t) => (
        <button key={t.key} type="button" role="tab" aria-selected={current === t.key} className={`tf-tab${current === t.key ? ' on' : ''}`} onClick={() => onChange(t.key)}>
          {t.icon}{t.label}{t.count != null && <em className={t.warm ? 'warm' : ''}>{t.count}</em>}
        </button>
      ))}
    </div>
  );
}

// panelWidth: the side panel's width. The menu card is then only as wide as the list, not as the page.
export default function TrailFrame({ current, tabs, right, children, panelWidth }) {
  const cardRef = useRef(null);
  const topRef = useRef(null);
  // The side panel reaches up beside the menu card, so its top is the menu card's top, as on the other pages. It needs to know how tall
  // the menu card is (plus the gap under it), and that changes with the tabs and the window.
  useEffect(() => {
    if (!panelWidth || !topRef.current || !cardRef.current) return undefined;
    const set = () => cardRef.current && cardRef.current.style.setProperty('--tf-top-h', `${topRef.current.offsetHeight + 8}px`);
    set();
    if (typeof ResizeObserver === 'undefined') return undefined;
    const ro = new ResizeObserver(set);
    ro.observe(topRef.current);
    return () => ro.disconnect();
  }, [panelWidth]);
  return (
    <div ref={cardRef} className={`tf-card${panelWidth ? ' tf-card--panel' : ''}`} style={panelWidth ? { '--tf-pw': `${panelWidth}px` } : undefined}>
      <div className="tf-top" ref={topRef}>
        <TrailSwitch current={current} />
        {tabs && <div className="tf-tabsrow">{tabs}</div>}
        {right && <div className="tf-right">{right}</div>}
      </div>
      <div className="tf-body">{children}</div>
    </div>
  );
}

// While a page is loading the frame is already there, so the three pages do not appear as three different pages.
export function TrailPageLoading({ current, text, panelWidth }) {
  return (
    <div className="cmp dc-page">
      <div className="head tf-head">
        <div>
          <div className="eye">Dokumentation</div>
          <h1>Revisionsspor</h1>
          <p>{text}</p>
        </div>
      </div>
      <TrailFrame current={current} panelWidth={panelWidth}><div className="tf-loading"><LoadingState /></div></TrailFrame>
    </div>
  );
}
